<script lang="ts">
    import {Button, ButtonGroup, Modal} from "flowbite-svelte";
    import {globalConfirm} from "$lib/stores/modal";
    import {globalToast} from "$lib/stores/toast";
    import {ExclamationCircleSolid} from "flowbite-svelte-icons";
    let showModal = false

    $globalToast.color = 'green'
</script>
<ButtonGroup>
    <Button on:click={() => {$globalConfirm.confirm('Do you agree?')}}>Confirm</Button>
    <Button on:click={() => {$globalToast.timed('info', 5000, ExclamationCircleSolid)}}>Toast</Button>
    <Button on:click={() => {showModal=true}}>Modal</Button>
</ButtonGroup>
<Modal title="Demomodal" bind:open={showModal}>
    Modal
</Modal>
